import React, { Component } from "react";
import { Link } from "react-router-dom";
import anime from "animejs";
import _ from "lodash";
import { withRedux } from "../../hoc";
import { Parallax } from "react-skrollr";
import { Button, MyWaypoint, Feather, Image } from "../../components";

const feather2 = `${process.env.PUBLIC_URL}/assets/images/section-4/feather4-2.png`;

const mapStateToProps = ({ language, t, event }) => {
  return {
    language,
    t,
    events: _.get(event, "data")
  };
};

@withRedux(mapStateToProps)
export default class Section4 extends Component {
  constructor(props) {
    super(props);
    this.sectionRef = React.createRef();
  }
  render() {
    const { events, t } = this.props;
    const upcommingEvent = _.last(events);
    const logoEvent = _.get(upcommingEvent, 'logo.full_file_path')
    return (
      <div className="section-4" ref={this.sectionRef}>
        <div className="container-parallax-feather-left">
          <div className="container-feather-left">
            <Image src={feather2} alt="" />
          </div>
        </div>
        <div className="main-content">
          <div className="container">
            <div className="row align-items-center">
              <div className="col-md-6 col-sm-12">
                <MyWaypoint
                  anime={[
                    () =>
                      anime({
                        targets: this.sectionRef.current.querySelector(".img-block"),
                        rotateY: [0, 180],
                        easing: "easeInOutSine",
                        duration: 1500
                      })
                  ]}
                >
                  <div className="img-block" style={{ backgroundImage: `url('${_.get(upcommingEvent, "image")}')` }} />
                </MyWaypoint>
              </div>
              <div className="col-md-6 col-sm-12">
                <MyWaypoint
                  anime={[
                    () =>
                      anime({
                        targets: ".section-4 .content li",
                        opacity: [0.4, 1],
                        translateY: [50, 0],
                        easing: "easeInOutSine",
                        duration: (el, i, l) => {
                          return 800 + i * 20 * 2;
                        },
                        delay: (el, i, l) => {
                          return 500 + i * 100;
                        }
                      })
                  ]}
                >
                  <ul className="content">
                    {/* <li>
                      <h2>Event</h2>
                    </li> */}
                    <li>
                      <div className="logo-img">
                        <Image src={logoEvent} alt="" />
                      </div>
                    </li>
                    <li>
                      <h2>{t(_.get(upcommingEvent, "title"))}</h2>
                    </li>
                    <li>
                      <div className="paragraph">
                        <div
                          dangerouslySetInnerHTML={{
                            __html: t(_.get(upcommingEvent, "description"))
                          }}
                        />
                      </div>
                    </li>
                    <li>
                      <Link to={`/event/detail/${_.get(upcommingEvent, "id")}`}>
                        <Button ghost bordercolor="#ffb400">
                          Read More
                        </Button>
                      </Link>
                    </li>
                  </ul>
                </MyWaypoint>
              </div>
            </div>
          </div>
        </div>
        <div className="feather-block">
          <div className="feather feather-1">
            <Parallax
              data={{
                "data-bottom-top":
                  "transform: translateX(-20px) translateY(-200px) translateZ(0px) scale(1) rotate(30deg);",
                "data-top-bottom": "transform: translateX(0px) translateY(0px) translateZ(0px) scale(1) rotate(10deg);"
              }}
            >
              <Feather type={8} />
            </Parallax>
          </div>
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/pages/Home/Section4.js